import React from 'react'

import GraphImg from './img/graph.png'

export const TabManager: React.FC = () => {
    return (
        <div className="flex flex-col md:grid grid-cols-2 gap-4">
            <div className="card_item card_item_dark row-span-2">
                <h2>Что получит руководитель</h2>
                <div>
                    <ul>
                        <li className="!mt-6">
                            <b>Помощь для принятия решений</b>
                            <br />
                            Встроенная валидация на соблюдение нацрежима, на
                            правильность формы и способа закупки
                        </li>
                        <li className="!mt-6">
                            <b>Контроль лимитов и бюджета</b>
                            <br />
                            Автоматическое формирование закупочной документации
                            — план закупки, извещение, документация, протоколы
                        </li>
                        <li className="!mt-6">
                            <b>Экономия средств</b>
                            <br />
                            Вы можете загрузить заявки и планы закупок из Excel
                            в систему, а также выгружать отчеты, реестры и
                            аналитику в привычном вам формате
                        </li>
                        <li className="!mt-6">
                            <b>Актуальная аналитика</b>
                            <br />
                            Формирует любую отечность, в том числе объем закупок
                            у МСП, отчетность по экономии, лимиты и т.д.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card_item card_item_dark flex">
                <div className="leading-8 font-bold grow">
                    <div>Порядок</div>
                    <div>Аналитика</div>
                    <div>Контроль</div>
                    <div>Экономия</div>
                    <div>Ускороние</div>
                </div>
                <div className="hidden md:flex flex-col w-1/6 gap-2">
                    <div className="h-1.5 rounded-lg bg-[#3C3940]"></div>
                    <div className="h-1.5 rounded-lg bg-[#3C3940]"></div>
                    <div className="h-1.5 rounded-lg bg-[#3C3940]"></div>
                    <div className="h-1.5 rounded-lg bg-[#3D70F3]"></div>
                    <div className="h-1.5 rounded-lg bg-[#3D70F3]"></div>
                    <div className="h-1.5 rounded-lg bg-[#3D70F3]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                    <div className="h-1.5 rounded-lg bg-[#1051F5]"></div>
                </div>
            </div>
            <div className="card_item card_item_dark !pb-0">
                <h2>Аналитика для контроля</h2>
                <img src={GraphImg} />
            </div>
        </div>
    )
}
